import { supabase } from "../../data/supabase/client";

/**
 * Invokes Claude API through Supabase Edge Function with streaming support
 *
 * @param functionName - The name of the edge function to call (e.g., "claude-query")
 * @param payload - The request payload to send to Claude
 * @returns The Response object for streaming
 */
export async function invokeClaudeStream<TRequest = any>(
  functionName: string,
  payload: TRequest
): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession();

  if (!session) {
    throw new Error("Not authenticated");
  }

  // Use fetch directly for streaming because supabase.functions.invoke
  // doesn't support streaming responses yet
  return fetch(
    `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${functionName}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${session.access_token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    }
  );
}
